import ItineraryTimeline from "../PackageInfo/ItineraryTimeline";
import Header from "../PackageInfo/Header";
import ModalTriggerList from "../CommonUI/ModalTriggerList";
import JoinEventAction from "../CommonUI/JoinEventAction";
import TrekBasicInfo from "../CommonUI/TrekBasicInfo";
import PackageInclusions from "../CommonUI/PackageInclusions";
import ImageCardsWithVerticalView from "../PackageInfo/ImageCardsWithverticalView";

import kw1 from "../../Images/KaluWaterfall/kw1.jpg";
import kw2 from "../../Images/KaluWaterfall/kw2.JPG";
import kw3 from "../../Images/KaluWaterfall/kw3.JPG";
import dev3 from "../../Images/Devkund/dev3.jpg";
import dev4 from "../../Images/Devkund/dev4.jpg";

const data = [
  {
    day: "Day 1",
    subheading: "Departure from Pune",
    schedule: [
      { time: "09:00 PM", activity: "Pickup at PMC Bus Stop opposite Congress Bhavan, Hadapsar." },
      { time: "09:15 PM", activity: "Pickup at Bank of Maharashtra, Shivajinagar." },
      { time: "09:45 PM", activity: "Pickup at Nashik Phata." },
      {
        time: "Late Night",
        activity:
          "Overnight travel toward the Karoli Valley region with rest time on the bus.",
      },
    ],
    meals: ["Night travel"],
    notes: [
      "Please be ready at your pickup point 10 minutes before the scheduled time. The group departs promptly to keep the overnight schedule comfortable.",
    ],
  },
  {
    day: "Day 2",
    subheading: "Karoli Valley Trek",
    schedule: [
      { time: "04:00 AM", activity: "Reach the base village. Freshen up and take some time to rest." },
      { time: "05:00 AM", activity: "Enjoy breakfast and refreshments before the trek." },
      { time: "06:00 AM", activity: "Begin the trek after a safety briefing by our trek leaders." },
      {
        time: "09:00 AM",
        activity:
          "Explore the mesmerizing jungle trail, natural streams, lush greenery, and breathtaking Sahyadri landscape.",
      },
      {
        time: "09:00 AM - 10:00 AM",
        activity:
          "Stop for nature photography and capture unforgettable monsoon memories.",
      },
      { time: "10:00 AM", activity: "Begin the return trek to the base village." },
      { time: "01:00 PM", activity: "Reach the base village and enjoy a delicious lunch." },
      { time: "02:30 PM", activity: "Start the return journey to Pune." },
      { time: "09:00 PM - 10:00 PM", activity: "Approximate arrival in Pune with great memories." },
    ],
    meals: ["Breakfast", "Lunch", "Tea"],
    notes: [
      "The day includes an early morning trek, jungle scenery, refreshing streams, and beautiful opportunities for photography.",
    ],
    inclusions: [
      "🚌 Private Bus Travel (Pune to Pune)",
      "🍽️ Breakfast",
      "🍛 Veg Lunch",
      "🥾 Experienced Trek Leader",
      "⛑️ First Aid Support",
      "📋 Trek Management & Coordination",
    ],
    exclusions: [
      '🚫 Personal Expenses',
      '🚫 Bottled Water & Additional Snacks',
      '🚫 Medical/Travel Insurance',
      '🚫 Anything Not Mentioned in Inclusions',
    ],
    verticalCards: [
      { title: "Karoli Valley Trail", image: kw1 },
      { title: "Natural Water Streams", image: kw2 },
      { title: "Forest Trail", image: kw3 },
      { title: "Scenic Valley View", image: dev4 },
      { title: "Sahyadri Range", image: dev3 },
    ],
    trekData: [
      {
        name: "Karoli Valley Trek",
        image: kw1,
        info: "Escape the city and discover Karoli Valley's hidden beauty. This trek takes you through dense forest trails, crystal-clear water streams, and sweeping Sahyadri mountain views. Perfect for monsoon adventure seekers, the route offers refreshing scenery, excellent photography spots, and a peaceful nature walk with friends and fellow explorers.",
      },
    ],
    faq: [
      {
        question: "What are the pickup points?",
        answer:
          "Pickup points include Hadapsar, Shivajinagar, and Nashik Phata.",
      },
      {
        question: "What is included in the package?",
        answer:
          "The package includes private bus travel, breakfast, veg lunch, an experienced trek leader, first aid support, and trek coordination.",
      },
      {
        question: "Is the trek good for photography?",
        answer:
          "Yes, the trek offers stunning nature photography opportunities with waterfalls, streams, and Sahyadri vistas.",
      },
      {
        question: "When will we return to Pune?",
        answer:
          "The return journey departs at 2:30 PM and you can expect to arrive back in Pune around 9:00–10:00 PM, depending on traffic.",
      },
    ],
  },
];

const KaroliValley = () => {
  return (
    <div className="bg-gray-50 ">
      <Header trekData={data[1].trekData[0]} />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <TrekBasicInfo
          trekName="Karoli Valley Trek"
          location="Karoli Valley"
          trekDifficulty="Moderate"
          ageLimit="16 to 36 Years"
        />
        <PackageInclusions />
      </div>
      <ItineraryTimeline itinerary={data} />
      <ImageCardsWithVerticalView verticalCards={data[1].verticalCards} />
      <ModalTriggerList
        inclusions={data[1].inclusions}
        exclusions={data[1].exclusions}
        type="trek"
        faq={data[1].faq}
      />
      <JoinEventAction />
    </div>
  );
};

export default KaroliValley;
